<div class="button-box">
  <button mat-raised-button class="btn agendamento" (click)="goToSchedule()">Agendamento</button>
  <button mat-raised-button class="btn checkin" (click)="goToCheckin()">Checkin</button>
  <button mat-raised-button class="btn resultados" (click)="goToExams()">Resultados/Documentos</button>
</div>
